import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';

// auth provider
import { JWTProvider } from 'contexts/JWTContext';

// Prismic provider
import { PrismicProvider } from '@prismicio/react';
import { client } from './prismic';

// hooks
import useMaintenance from 'hooks/useMaintenance';

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);
    const market_settings = useMaintenance();

    // Override page title with localized website name
    useEffect(() => {
        
        if (market_settings?.description && market_settings?.description.length < 60) {
            document.title = `Philips - ${market_settings.description}`;
        }
        else if (market_settings?.name) {
            document.title = `Philips - AVENT SAMPLESHOP ${market_settings.name}`;
        }
    }, [market_settings?.name, market_settings.description]);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />

                <Locales>
                    <NavigationScroll>
                        <PrismicProvider client={client}>

                            <JWTProvider>
                                <>
                                    <Routes />
                                    <Snackbar />
                                </>
                            </JWTProvider>
                        </PrismicProvider>
                    </NavigationScroll>
                </Locales>

            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
